function ReadmeBadge({ name, value }) {
  return (
    <div className="badge">
      <p className="name">{name}</p>
      <p className="value">{value}</p>
    </div>
  );
}

export default ReadmeBadge;
